module.exports = __webpack_public_path__ + "static/media/image13.a99852dd.JPG";